// Producted Flow Rate - Q_l stbd
// Avg Reservoir Pressure - P_r psia
// Well Flowing Pressure - P_wf psia
// Returns PI
export function getProductivityIndex(
  produced_flow_rate: number,
  average_reservoir_pressure: number,
  well_flowing_pressure: number
): number {
  return (
    produced_flow_rate / (average_reservoir_pressure - well_flowing_pressure)
  );
}

export function getJValue(
  p_wf_test: number,
  p_b: number,
  q_rate_test: number,
  p_r: number
): number {
  return p_wf_test > p_b
    ? q_rate_test / (p_r - p_wf_test)
    : q_rate_test /
        (p_r -
          p_b +
          (p_b / 1.8) *
            (1 - 0.2 * (p_wf_test / p_b) - 0.8 * (p_wf_test / p_b) ** 2));
}

export function getQmax(
  p_r: number,
  p_b: number,
  q_rate_test: number,
  p_wf_test: number,
  q_b: number,
  j_number: number
): number {
  return p_r <= p_b
    ? // =E8/(1-0.2*(E5/E4)-0.8*(E5/E4)^2)
      q_rate_test / (1 - 0.2 * (p_wf_test / p_r) - 0.8 * (p_wf_test / p_r) ** 2)
    : // =E23+(E21*E6)/1.8
      q_b + (j_number * p_b) / 1.8;
}

export function getPWF(
  waterCutRatio: number,
  reservoirPressurePSIA: number,
  targetLiquidFlowRateSTBD: number,
  targetOilRateSTBD: number,
  q_b: number,
  p_b: number,
  q_max: number,
  j_oil: number,
  j_water: number
): number {
  if (targetOilRateSTBD > q_b && reservoirPressurePSIA > p_b) {
    return (
      0.125 *
      p_b *
      (-1 + Math.sqrt(81 - 80 * ((targetOilRateSTBD - q_b) / (q_max - q_b))))
    );
  } else if (targetOilRateSTBD > q_b) {
    // (q_o >= q_b && p_r < p_b)
    return (
      0.125 *
      reservoirPressurePSIA *
      (-1 + Math.sqrt(81 - 80 * ((targetOilRateSTBD - q_b) / (q_max - q_b))))
    );
  } else if (waterCutRatio === 1) {
    return reservoirPressurePSIA - targetLiquidFlowRateSTBD / j_water;
  } else {
    return reservoirPressurePSIA - targetOilRateSTBD / j_oil;
  }
}

export function getMaxFlowRatePI(
  reservoirPressurePSIA: number,
  wellFlowingPressureTestPSIA: number,
  desiredWellFlowingPressurePSIA: number,
  totalLiquidFlowRateSTBD: number,
  productivityIndex: number | null
): number {
  const pi =
    productivityIndex ||
    getProductivityIndex(
      totalLiquidFlowRateSTBD,
      reservoirPressurePSIA,
      wellFlowingPressureTestPSIA
    );

  return (reservoirPressurePSIA - desiredWellFlowingPressurePSIA) * pi;
}

export function getWellFlowingPressureUsingPi(
  totalLiquidFlowRateSTBD: number,
  reservoirPressurePSIA: number,
  wellFlowingPressureTestPSIA: number,
  desiredLiquidFlowRateSTBD: number,
  productivityIndex: number | null
): number {
  const pi =
    productivityIndex ||
    getProductivityIndex(
      totalLiquidFlowRateSTBD,
      reservoirPressurePSIA,
      wellFlowingPressureTestPSIA
    );
  if (pi === 0) {
    return 0;
  }

  return reservoirPressurePSIA - desiredLiquidFlowRateSTBD / pi;
}
